module.exports = __webpack_public_path__ + "img/zc-08.134ab84a.svg";